module.exports = __webpack_public_path__ + "img/up_qa.c2f7e739.svg";